var _path, _path2, _line, _line2, _line3, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResulticon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 34 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6418 2.83946V29.6431C32.6418 29.8846 32.5942 30.1238 32.5018 30.347C32.4093 30.5702 32.2738 30.773 32.103 30.9438C31.9322 31.1146 31.7294 31.2501 31.5063 31.3425C31.2831 31.435 31.0439 31.4825 30.8023 31.4825H28.4373V7.39433C28.4373 6.91024 28.2465 6.44565 27.9063 6.10131C27.5661 5.75697 27.1038 5.56063 26.6197 5.55486H5.20312V2.83946C5.20881 2.35337 5.40444 1.88879 5.74818 1.54505C6.09192 1.20131 6.5565 1.00569 7.04259 1H30.8023C31.2884 1.00569 31.753 1.20131 32.0967 1.54505C32.4405 1.88879 32.6361 2.35337 32.6418 2.83946Z",
    stroke: "#303030",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5992 5.55469H2.83946C1.82356 5.55469 1 6.37824 1 7.39415V34.1978C1 35.2137 1.82356 36.0372 2.83946 36.0372H26.5992C27.6151 36.0372 28.4387 35.2137 28.4387 34.1978V7.39415C28.4387 6.37824 27.6151 5.55469 26.5992 5.55469Z",
    stroke: "#303030",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.3598,
    y1: 11.3492,
    x2: 17.9191,
    y2: 11.3492,
    stroke: "#303030",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5.97891,
    y1: 20.1109,
    x2: 22.2976,
    y2: 20.1109,
    stroke: "#303030",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 5.97891,
    y1: 28.8687,
    x2: 13.5383,
    y2: 28.8687,
    stroke: "#303030",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3281 27.2758L18.2746 29.4656L22.1677 25.0859",
    stroke: "#303030",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResulticon);
export default __webpack_public_path__ + "static/media/resulticon.e95945051da6869d7e66f7ced0757e96.svg";
export { ForwardRef as ReactComponent };